module.exports = __webpack_public_path__ + "img/HOME-5.8bbaa47d.png";